/**
 * Sydney's Plant Market — GSAP Animations
 * Requires: gsap.min.js + ScrollTrigger.min.js (loaded before this file)
 */

(function () {
  'use strict';

  // Wait for GSAP to be available
  if (typeof gsap === 'undefined') {
    console.warn('SPM Animations: GSAP not loaded.');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // =============================================
  // HERO ANIMATIONS (page load)
  // =============================================
  const hero = document.querySelector('[data-hero]');

  if (hero) {
    const tl = gsap.timeline({ defaults: { ease: 'power1.out' } });

    const eyebrow = hero.querySelector('[data-hero-eyebrow]');
    const title   = hero.querySelector('[data-hero-title]');
    const sub     = hero.querySelector('[data-hero-subtitle]');
    const actions = hero.querySelector('[data-hero-actions]');
    const trust   = hero.querySelector('[data-hero-trust]');
    const scroll  = hero.querySelector('[data-hero-scroll]');

    if (eyebrow) tl.fromTo(eyebrow, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.9 }, 0.3);
    if (title)   tl.fromTo(title,   { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 1.1 }, 0.5);
    if (sub)     tl.fromTo(sub,     { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.9 }, 0.8);
    if (actions) tl.fromTo(actions, { opacity: 0, y: 8  }, { opacity: 1, y: 0, duration: 0.8 }, 1.1);
    if (trust)   tl.fromTo(trust,   { opacity: 0, y: 8  }, { opacity: 1, y: 0, duration: 0.8 }, 1.3);
    if (scroll)  tl.fromTo(scroll,  { opacity: 0        }, { opacity: 1,        duration: 0.6 }, 1.7);
  }

  // =============================================
  // HERO PARALLAX
  // =============================================
  const heroBg = document.querySelector('[data-hero-bg]');

  if (heroBg) {
    gsap.to(heroBg, {
      yPercent: 25,
      ease: 'none',
      scrollTrigger: {
        trigger: heroBg.closest('[data-hero]') || heroBg,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  // =============================================
  // SCROLL ANIMATIONS — Section headings
  // =============================================
  gsap.utils.toArray('[data-animate]').forEach((el) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

  // =============================================
  // SCROLL ANIMATIONS — Staggered grids
  // =============================================
  gsap.utils.toArray('[data-stagger]').forEach((container) => {
    const items = container.children;

    gsap.fromTo(
      items,
      { opacity: 0, y: 40, scale: 0.97 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.55,
        ease: 'power2.out',
        stagger: {
          amount: 0.5,
          from: 'start',
        },
        scrollTrigger: {
          trigger: container,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

  // =============================================
  // STICKY HEADER — smooth compact transition
  // =============================================
  // The CSS handles the visual change via .is-scrolled class.
  // GSAP handles any extra smoothness needed here.

  // =============================================
  // CATEGORY TILES — entrance on scroll
  // =============================================
  gsap.utils.toArray('.category-tile, .shop-category-tile').forEach((tile, i) => {
    gsap.fromTo(
      tile,
      { opacity: 0, scale: 0.98 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.9,
        ease: 'sine.out',
        delay: i * 0.04,
        scrollTrigger: {
          trigger: tile,
          start: 'top 92%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

  // Footer animation removed — GSAP y-transforms near bottom of page
  // extend scroll height and create blank space below footer.

  // =============================================
  // GARDEN CLUB SECTION — pulse the icon
  // =============================================
  const gardenClubIcon = document.querySelector('.garden-club__icon');

  if (gardenClubIcon) {
    gsap.to(gardenClubIcon, {
      scale: 1.08,
      duration: 1.8,
      ease: 'sine.inOut',
      yoyo: true,
      repeat: -1,
      scrollTrigger: {
        trigger: gardenClubIcon,
        start: 'top 90%',
      },
    });
  }

  // =============================================
  // PRODUCT CARDS — hover tilt (subtle)
  // =============================================
  document.querySelectorAll('.product-card').forEach((card) => {
    card.addEventListener('mousemove', (e) => {
      const rect   = card.getBoundingClientRect();
      const x      = (e.clientX - rect.left) / rect.width  - 0.5;
      const y      = (e.clientY - rect.top)  / rect.height - 0.5;
      const maxRot = 3;

      gsap.to(card, {
        rotateY:  x * maxRot,
        rotateX: -y * maxRot,
        duration: 0.3,
        ease: 'power2.out',
        transformPerspective: 800,
        transformOrigin: 'center center',
      });
    });

    card.addEventListener('mouseleave', () => {
      gsap.to(card, {
        rotateY: 0,
        rotateX: 0,
        duration: 0.5,
        ease: 'power3.out',
      });
    });
  });

  // =============================================
  // TESTIMONIAL CARDS — fade in when entering view
  // =============================================
  gsap.utils.toArray('.testimonial-card').forEach((card, i) => {
    gsap.fromTo(
      card,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
        delay: i * 0.1,
        scrollTrigger: {
          trigger: card,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

  // =============================================
  // HORIZONTAL RULE ANIMATION (section dividers)
  // =============================================
  gsap.utils.toArray('.section-heading-block__rule').forEach((rule) => {
    gsap.fromTo(
      rule,
      { scaleX: 0, transformOrigin: 'center center' },
      {
        scaleX: 1,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: rule,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

})();
